import { Customization } from '../../../../types/Customization'
import Heading from '../../../../components/Heading'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../../components/Button'
import Checkbox from '../../../../components/Checkbox'
import { StoredTemplate } from '../../../../types/Individualization'
import {
    exportPdfPerPage,
    exportTemplateSvg,
    exportPdfPerSpot,
} from '../../../../helpers/exportPdf'
import { useFetchData } from '../../../../hooks/useFetchData'
import { Font } from '../../../../types/Font'
import { ApiRoutes } from '../../../../services/ApiService'

const CustomizationExport: React.FC<{
    activeTemplate: StoredTemplate | null
    customization: Customization
    templates: StoredTemplate[]
}> = ({ activeTemplate, customization, templates }) => {
    const { t } = useTranslation(['fulfillment'])
    const [singlePage, setSinglePage] = useState<boolean>(false)

    const { data: fonts, fetch: fetchFonts } = useFetchData<Font>(
        ApiRoutes.FONTS
    )

    useEffect(() => {
        fetchFonts()
    }, [fetchFonts])

    return (
        <div>
            <Heading level={3} classes={'zr-mb-2'}>
                {t('detail.export.heading')}
            </Heading>
            <div
                className={'zr-d-flex zr-gap-4 zr-mb-2'}
                style={{ flexWrap: 'wrap' }}
            >
                <Button
                    hierarchy={'primary'}
                    text={t('detail.export.perSite')}
                    fn={() => {
                        if (activeTemplate && singlePage) {
                            return exportPdfPerPage(
                                [activeTemplate],
                                customization,
                                fonts
                            )
                        }
                        return exportPdfPerPage(
                            templates,
                            customization,
                            fonts
                        )
                    }}
                />
                <Button
                    hierarchy={'primary'}
                    text={t('detail.export.perSpot')}
                    fn={() => {
                        if (activeTemplate && singlePage) {
                            return exportPdfPerSpot(
                                customization,
                                [activeTemplate],
                                fonts
                            )
                        }
                        return exportPdfPerSpot(customization, templates, fonts)
                    }}
                />
            </div>
            <Checkbox
                classes={'zr-mb-4'}
                property={'allPages'}
                value={singlePage}
                label={t('detail.export.all')}
                onChange={(_, v) => setSinglePage(v)}
            />
            <Heading level={3} classes={'zr-mb-2'}>
                {'SVG-' + t('detail.export.heading')}
            </Heading>
            <Button
                hierarchy={'primary'}
                text={t('detail.export.asSVG')}
                fn={() => {
                    if (activeTemplate)
                        exportTemplateSvg(
                            activeTemplate,
                            customization,
                            fonts
                        )
                }}
            />
            <div>
                <small> {t('detail.export.asSvgDesc')} </small>
            </div>
        </div>
    )
}

export default CustomizationExport
